import React from 'react'
import DumoHeaderIcon from '../../svg/normalSvgs/DumoHeader.svg'
import { useUser } from '../../context/user'
import { useTranslation } from 'react-i18next'

function DumoHeader({ setTransferDumoModalOpen }) {
    const { availablePoints } = useUser()
    const { t } = useTranslation()
    return (
        <div className="dumo-header" style={{ backgroundImage: `url(${DumoHeaderIcon})` }}>
            <div className="dumo-header-title">
                {t('Points Earned')} <span className="dumo-header-title-span">{availablePoints}</span>
            </div>
            {/* <div className='dumo-header-subtitle'>
				<span style={{ fontWeight: 700 }}>{}</span> {t('10 more points possible to earn today')}
			</div>
			<button className='dumo-header-button' onClick={() => setTransferDumoModalOpen(true)}>
				{t('Connect with Dummo account')}
			</button> */}
        </div>
    )
}

export default DumoHeader
